import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';
import { AppContext } from '../app-context';
import { Legal } from './styles';

type Props = {
  privacyPolicyUri: string;
};

const LegalLink = ({ privacyPolicyUri }: Props) => {
  const { t } = useContext(AppContext);
  return (
    <Legal>
      {privacyPolicyUri && (
        <Link
          to={privacyPolicyUri}
          // This link is nofollow to avoid it getting too much of the internal
          // pagerank (since it occurs on every page).
          rel="nofollow"
          onClick={() =>
            trackInternalNavigationClick({
              scope: InternalNavigationScope.NEWSLETTER_EMAIL_PRIVACY,
              nextPage: privacyPolicyUri,
            })
          }
        >
          {t('product', 'alert.how-your-email-is-used')}
        </Link>
      )}
    </Legal>
  );
};

export default LegalLink;
